import { render, staticRenderFns } from "./SupportCenter.vue?vue&type=template&id=c3d92252&scoped=true"
import script from "./SupportCenter.vue?vue&type=script&lang=js"
export * from "./SupportCenter.vue?vue&type=script&lang=js"
import style0 from "./SupportCenter.vue?vue&type=style&index=0&id=c3d92252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d92252",
  null
  
)

export default component.exports